export default {
    actions: {
        loadAccounts() {
            return this.dispatch('sendRequest', { path: '/finance/account', method: 'get', formErrors: {} });
        },
        loadAccount(state, {id}) {
            return this.dispatch('sendRequest', { path: '/finance/account/'+id, method: 'get', formErrors: {} });
        },
        createAccount(state, {data, formErrors}) {
            return this.dispatch('sendRequest', { path: '/finance/account', data, method: 'post', formErrors });
        },
        editAccount(state, {data, formErrors, id}) {
            return this.dispatch('sendRequest', { path: '/finance/account/'+id, data, method: 'post', formErrors });
        },

        loadGroups(state, {params}) {
            return this.dispatch('sendRequest', { path: '/finance/group', params, method: 'get', formErrors: {} });
        },
        loadGroup(state, {id}) {
            return this.dispatch('sendRequest', { path: '/finance/group/'+id, method: 'get', formErrors: {} });
        },
        createGroup(state, {data, formErrors}) {
            return this.dispatch('sendRequest', { path: '/finance/group', data, method: 'post', formErrors });
        },
        editGroup(state, {data, formErrors, id}) {
            return this.dispatch('sendRequest', { path: '/finance/group/'+id, data, method: 'post', formErrors });
        },

        loadTransactions(state, {params}) {
            return this.dispatch('sendRequest', { path: '/finance/transaction', params, method: 'get', formErrors: {} });
        },
        loadTransaction(state, {id}) {
            return this.dispatch('sendRequest', { path: '/finance/transaction/'+id, method: 'get', formErrors: {} });
        },
        createTransaction(state, {data, formErrors}) {
            return this.dispatch('sendRequest', { path: '/finance/transaction', data, method: 'post', formErrors });
        },
        editTransaction(state, {data, formErrors, id}) {
            return this.dispatch('sendRequest', { path: '/finance/transaction/'+id, data, method: 'post', formErrors });
        },
        deleteTransaction(state, {id}) {
            return this.dispatch('sendRequest', { path: '/finance/transaction/'+id, method: 'delete' });
        },

        createTransfer(state, {data, formErrors}) {
            return this.dispatch('sendRequest', { path: '/finance/transfer', data, method: 'post', formErrors });
        },
        loadTransfer(state, {id}) {
            return this.dispatch('sendRequest', { path: '/finance/transfer/'+id, method: 'get', formErrors: {} });
        },
        editTransfer(state, {data, formErrors, id}) {
            return this.dispatch('sendRequest', { path: '/finance/transfer/'+id, data, method: 'post', formErrors });
        },

        createMonthBudget(state, {data, formErrors}) {
            return this.dispatch('sendRequest', {path: '/finance/month-budget', method: 'post', data, formErrors});
        },
        loadMonthBudgets(state, {params}) {
            return this.dispatch('sendRequest', {path: '/finance/month-budget', params});
        },
        editMonthBudget(state, {data, formErrors, id}) {
            return this.dispatch('sendRequest', {path: '/finance/month-budget/'+id, method: 'post', data, formErrors});
        },
        loadMonthBudget(state, {id}) {
            return this.dispatch('sendRequest', {path: '/finance/month-budget/'+id});
        },
        deleteMonthBudget(state, {id}) {
            return this.dispatch('sendRequest', {path: '/finance/month-budget/'+id, method: 'delete'});
        },
        loadMonthBudgetType() {
            return this.dispatch('sendRequest', {path: '/finance/month-budget-type'});
        },
        createMonthBudgetsFromOtherMonth(state, {data}) {
            return this.dispatch('sendRequest', {path: '/finance/month-budget-from-other-month', method: 'post', data});
        },
        loadMonthBudgetFromOtherMonth(state, {params}) {
            return this.dispatch('sendRequest', {path: '/finance/month-budget-from-other-month', params});
        }
    }
}